import api from 'services/api';
import { array, num, object, runSchema, str } from 'validation';

// Source of truth: nap-backend `GET /folders/:id/ancestors` (routes/folders.js).
// Returns a folder's zone and the chain of folders from the zone root down to
// (and including) the folder — used to expand the Workspace tree to a folder
// selected via a bookmarked/refreshed URL.

export interface FolderAncestors {
  readonly zoneId: number;
  // Folder ids from the zone root down to and including the target folder.
  readonly folderIds: readonly number[];
}

interface FolderAncestorsWire {
  readonly zone_id: number;
  readonly zone_name: string;
  readonly folders: readonly { readonly folder_id: number; readonly name: string }[];
}

const schema = object<FolderAncestorsWire>({
  zone_id: num(),
  zone_name: str(),
  folders: array(object<{ folder_id: number; name: string }>({ folder_id: num(), name: str() })),
});

export const parseFolderAncestors = (raw: unknown, source: string): FolderAncestors => {
  const result = runSchema(schema, raw, source);
  if (!result.ok) {
    throw new Error(`${source}: folder ancestors response failed validation`);
  }
  return {
    zoneId: result.value.zone_id,
    folderIds: result.value.folders.map((f) => f.folder_id),
  };
};

export const getFolderAncestors = async (folderId: number): Promise<FolderAncestors> => {
  const res = await api.get(`/folders/${folderId}/ancestors`);
  return parseFolderAncestors(res.data, 'getFolderAncestors');
};
